import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Tower from "@/pages/Tower";
import Roster from "@/pages/Roster";
import Settings from "@/pages/Settings";
import MyDay from "@/pages/MyDay";
import Chat from "@/pages/Chat";
import ChatNotifier from "@/components/ChatNotifier";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback (session_id in URL fragment) — handle synchronously
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ChatNotifier />
      <Routes>
      <Route path="/" element={<Navigate to="/board" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/board" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/tower" element={<ProtectedRoute><Tower /></ProtectedRoute>} />
      <Route path="/me" element={<ProtectedRoute><MyDay /></ProtectedRoute>} />
      <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
      <Route path="/roster" element={<ProtectedRoute requireManager><Roster /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute requireManager><Settings /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/board" replace />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
